<template>
    <div id="BlogDiv">
        <div class="iframe-view">
          <div class="text-center pt-0">
              <h2 class="black-color font-weight-normal text-center">Do any medical test at your home</h2>
              <img src="static/images/search-code-img.svg" alt="">
              <p>Our service is currently in Chennai & Bengaluru only</p>
              <div class="banner-fields">
                  <button class="btn btn-lg btn-primary mb-3" ref="pincodeSubmit" type="button" v-on:click.self="goTest()" v-on:keyup.enter="goTest()">
                      Book Test
                  </button>
              </div>
          </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'BlogFrame',
  components: {
  },
  beforeCreate () {
    this.query = this.$localStorage.get('location')
  },
  data () {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    }
  },    
  methods: {
    goTest: function () {
    //   this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : ''
    //   if (!this.selectedLocation) {
    //     return false
    //   }
    //   this.$localStorage.set('location', this.selectedLocation, 0)
    //   this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0)
    //   this.$root.$emit('bookTest', true)
      window.open(this.$blogRedirectUrl, 'myWindow')
    },
    searchLocation: function (query) {
      this.onBlurKey = 'block'
      this.selectedLocation = undefined
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      if (this.query.length < 3) {
        this.onBlurKey = 'none'
        this.items = []
        return false
      }
      try {
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'keyword': this.query
          }
          Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res)
            if (res.response_code === 0) {
              this.items = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    closeBlock: function () {
      setTimeout(function () {
        this.onBlurKey = 'none'
      }.bind(this), 300)
    },
    selectLocation: function (event, obj) {
      this.selectedLocation = undefined
      this.selectedLocation = obj
      this.selectedPincode = obj.locationZipCode
      this.query = obj.locationName + '-' + obj.locationZipCode
      this.items = []
      this.onBlurKey = 'none'
    }
  },
  watch: {
    address: function (val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal)
    }
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
body {
    overflow-y: hidden !important;
}
.banner-fields ul {
    position: absolute;
    padding: 0px;
    background-color: #FFF;
    width: 100%;
    z-index: 3;
    max-height: 170px;
    overflow-y: auto;
    top: 39px;
    border: 1px solid #DDD;
    overflow-x: hidden;
}

.banner-fields li {
    padding: 7.5px 15px;
    list-style: none;
    cursor: pointer;
    margin-bottom: 0;
}

.banner-fields {
    position: relative;
}

.sprite-facebook {
    background-position: -140px -83px;
}

.sprite-pintrest {
    background-position: -170px -83px;
}

.sprite-twitter {
    background-position: -203px -83px;
}

.sprite-instagram {
    background-position: -239px -83px;
}

h2.widget-title {
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: 400;
    text-transform: inherit;
}

.social-media {
    border: 1px solid #e1e1e1;
    padding: 15px;
    width: 100%;
}

ul {
    padding: 0px;
    margin: 0px;
}

.social-link li {
    display: inline-table;
    margin-right: 8.4%;
    margin-top: 15px;
}

.banner-fields button,
.banner-fields input {
    font-size: 14px;
}

.sprites {
    height: 25px;
    width: 25px;
    background-size: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/BlogFrame.vue